import { purchaseOrderIdFormat } from "@redotech/redo-model/ids";
import { PurchaseOrderStatus } from "@redotech/redo-prisma-client/enums";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const tagUpdateMode = ["add", "replace", "remove"] as const;

export const bulkUpdatePurchaseOrders = {
  name: "bulkUpdatePurchaseOrders" as const,
  input: z
    .object({
      purchaseOrderIds: z.array(purchaseOrderIdFormat.schema),
      status: createEnum(PurchaseOrderStatus).optional(),
      tags: z.array(z.string()).optional(),
      tagUpdateMode: z.enum(tagUpdateMode).optional(),
      orderDate: zExt.plainDate().nullish(),
    })
    .refine(
      (data) =>
        (data.tags === undefined) === (data.tagUpdateMode === undefined),
      { message: "tags and tagUpdateMode must be provided together" },
    ),
  output: z.object({ success: z.boolean() }),
};
